import {stateCode, dmaCode, regionCode, countryCode} from "./stateDMACode"
import categoriesData from "./categories.json"
import brandsData from "./brands.json"
import behavioralAudienceData from "./behavioralAudience.json"
import * as FileSaver from "file-saver"
import * as XLSX from "xlsx"

export const defaultGeo = {
  geoType: "COUNTRY",
  geoId: 0,
}

export const defaultMapGeos = {
  STATE: {
    requestId: 1,
    geos: [],
  },
  DMA: {
    requestId: 1,
    geos: [],
  },
  selected: null,
}

export const defaultTimePeriod = "SEVEN_DAYS"

export const zendeskUrl = `https://help.groundtruth.com/hc/en-us/articles/4407438586771-Discovery`

export function debounce(func, wait, immediate) {
  let timeout
  return function () {
    let context = this,
      args = arguments
    let later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    let callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}
export function toggleInputCloseButton(ref) {
  let sibling = ref.current.nextSibling
  if (ref.current.value !== "") {
    sibling.classList.add("close-button")
  } else {
    sibling.classList.remove("close-button")
  }
}

export function clearInputContent(ref) {
  ref.current.value = ""
  let sibling = ref.current.nextSibling
  sibling.classList.remove("close-button")
}

export function getStateName(geoObj) {
  let stateName

  switch (geoObj.type) {
    case "state":
      stateName = stateCode.find((obj) => obj.id === geoObj.id)
      break
    case "dma":
      stateName = dmaCode.find((obj) => obj.id === geoObj.id)
      break
    default:
      stateName = ""
      break
  }

  return stateName
}

export function categoryToSicCode(name) {
  for (let key in categoriesData.categories) {
    if (categoriesData.categories[key].name === name)
      return categoriesData.categories[key].code
  }
  return null
}

//sicCode as string
export function sicCodeToCategory(code) {
  for (let key in categoriesData.categories) {
    if (categoriesData.categories[key].code === code)
      return categoriesData.categories[key].name
  }
  return null
}

export function brandToBrandId(name) {
  for (let key in brandsData.brands) {
    if (brandsData.brands[key].name === name) return parseInt(brandsData.brands[key].id)
  }
  return null
}

//accepts brandId as number
export function brandIdToBrand(id) {
  // id could be null
  if (id) {
    for (let key in brandsData.brands) {
      if (brandsData.brands[key].id === id.toString()) return brandsData.brands[key].name
    }
  }
  return null
}

export function brandIdToCategory(id) {
  if (id != null) {
    for (let key in brandsData.brands) {
      if (brandsData.brands[key].id === id.toString())
        return brandsData.brands[key].category
    }
  }
  return null
}

export function brandToCategory(name) {
  for (let key in brandsData.brands) {
    if (brandsData.brands[key].name === name) return brandsData.brands[key].category
  }
  return null
}

export function dmaCodeToName(id) {
  for (let key in dmaCode) {
    if (dmaCode[key].id === id) return `${dmaCode[key].dma},${dmaCode[key].stateCode}`
  }
  return null
}

export function brandIdToSicCode(id) {
  for (let key in brandsData.brands) {
    if (brandsData.brands[key].id === id.toString()) return brandsData.brands[key].sic
  }
  return null
}

export function getCookieValue() {
  // inserts the nth parenthesized submatch string, provided the first argument was a RegExp object.
  // Note that this is 1-indexed.
  let cookieValue = document.cookie.replace(
    /(?:(?:^|.*;\s*)session\s*=\s*([^;]*).*$)|^.*$/,
    "$1"
  )

  return cookieValue
}

// clear all cookies in all paths and all variants of the domain (www.mydomain.com, mydomain.com etc)
export function clearCookies() {
  var cookies = document.cookie.split("; ")
  console.log(cookies)

  for (var c = 0; c < cookies.length; c++) {
    var d = window.location.hostname.split(".")
    while (d.length > 0) {
      var cookieBase =
        encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) +
        "=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=" +
        d.join(".") +
        " ;path="
      var p = window.location.pathname.split("/")
      document.cookie = cookieBase + "/"
      while (p.length > 0) {
        document.cookie = cookieBase + p.join("/")
        p.pop()
      }
      d.shift()
    }
  }
}

export function stateList() {
  const list = []
  for (let key in stateCode) {
    list.push(stateCode[key].state)
  }
  return list
}

export function dmaList() {
  const list = []
  for (let key in dmaCode) {
    if (dmaCode[key].dma !== null)
      list.push(`${dmaCode[key].dma}, ${dmaCode[key].stateCode}`)
  }
  return list
}

export function behavioralAudiences() {
  const list = []
  for (let key in behavioralAudienceData.ba) {
    //add only values with "display_text" keys, not "_display_text" (it's a JSON "comment")
    behavioralAudienceData.ba[key].display_text &&
      list.push(behavioralAudienceData.ba[key].display_text)
  }
  return list
}

export function removeTrailingLeadingChars(str) {
  //remove leading/trailing non word
  const text = str.replace(/^\W+|\W+$/g, "")

  return text
}

export const exportToCSV = (csvData, fileName) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
  const fileExtension = ".xlsx"
  const ws = XLSX.utils.json_to_sheet(csvData)
  const wb = {Sheets: {data: ws}, SheetNames: ["data"]}
  const excelBuffer = XLSX.write(wb, {bookType: "xlsx", type: "array"})
  const data = new Blob([excelBuffer], {type: fileType})
  FileSaver.saveAs(data, fileName + fileExtension)
}

//to convert brand name array to brand id array
export function brandArrayToBrandIdArray(brandArray) {
  const result = []
  for (const brand of brandArray) {
    result.push(brandToBrandId(brand))
  }
  return result
}

//to convert brand id array to brand name array
export function brandIdArrayToBrandArray(brandIdArray) {
  const result = []
  for (const brandId of brandIdArray) {
    result.push(brandIdToBrand(brandId))
  }
  return result
}

//to convert category array to sicCode array
export function catArrayToSicCodeArray(catArray) {
  const result = []
  for (const cat of catArray) {
    result.push(categoryToSicCode(cat))
  }
  return result
}

export function stateNameToId(name) {
  for (let key in stateCode) {
    if (stateCode[key].state === name) return stateCode[key].id
  }
  return null
}

export function stateIdToName(id) {
  for (let key in stateCode) {
    if (stateCode[key].id === id) return stateCode[key].state
  }
  return null
}

export function dmaNameToId(name) {
  for (let key in dmaCode) {
    if (dmaCode[key].dma === name) return dmaCode[key].id
  }
  return null
}

export function regionNameToId(name) {
  for (let key in regionCode) {
    if (regionCode[key].name === name) return regionCode[key].id
  }
  return null
}

export function countryIdToName(id) {
  for (let key in countryCode) {
    if (countryCode[key].id === id) return countryCode[key].name
  }
  return null
}

export function countryNameToId(name) {
  for (let key in countryCode) {
    if (countryCode[key].name === name) return countryCode[key].id
  }
  return null
}

export function regionIdToName(id) {
  for (let key in regionCode) {
    if (regionCode[key].id === id) return regionCode[key].name
  }
  return null
}

export function dmaIdToName(id) {
  for (let key in dmaCode) {
    if (dmaCode[key].id === id) return dmaCode[key].dma
  }
  return null
}

export const getRandomInt = (maximum, minimum) => {
  const min = Math.ceil(maximum)
  const max = Math.floor(minimum)
  return Math.floor(Math.random() * (max - min)) + min
}

export const getRandomFloat = (minimum, maximum) => {
  let randomNum = Math.random() * (maximum - minimum) + minimum
  return (Math.round(randomNum * 100) / 100).toFixed(2)
}

export const getCurrentTime = () => new Date().getTime()

//to covert behavioural audience backend key to text
export function baKeyToText(baKey) {
  for (let key in behavioralAudienceData.ba) {
    if (behavioralAudienceData.ba[key].backend_key === baKey)
      return behavioralAudienceData.ba[key].display_text
  }
  return null
}

//to covert behavioural audience text to backend key
export function baTextToKey(batext) {
  for (let key in behavioralAudienceData.ba) {
    if (behavioralAudienceData.ba[key].display_text === batext)
      return behavioralAudienceData.ba[key].backend_key
  }
  return null
}

//to convert behavioural audience backend key array to text array
export function baTextArrayToKeyArray(baTextArray) {
  const result = []
  for (const baText of baTextArray) {
    result.push(baTextToKey(baText))
  }
  return result
}

//to covert behavioural audience text array to backend key array
export function baKeyArrayToTextArray(baKeyArray) {
  const result = []
  for (const baKey of baKeyArray) {
    result.push(baKeyToText(baKey))
  }
  return result
}

export const URLPATHS = {
  LOCATIONGROUPS: "/locationgroups",
  LGLOCATIONS: "/locationgroups/locations",
  DISCOVERYBRANDS: "/brands/discovery",
  BRANDSLOCATIONS: "/brands/locations",
  INSIGHTS: "/insights",
  POI: "/poi",
  NOTFOUND: "/not-found",
}

export const GEOTYPE = {
  COUNTRY: "COUNTRY",
  STATE: "STATE",
  DMA: "DMA",
}

const convertToKM = (num, obj, noOfDecimalPlace) => {
  if (noOfDecimalPlace) {
    let reducedVal = parseFloat((num / obj.num).toFixed(noOfDecimalPlace))
    if (Number.isInteger(reducedVal)) {
      return Math.floor(reducedVal).toString() + obj.unit
    }
    return reducedVal.toString() + obj.unit
  } else {
    const remainder = num % obj.num
    const divisor = Math.floor(num / obj.num)
    const res = remainder < obj.num / 2 ? divisor : divisor + 1
    return res.toString() + obj.unit
  }
}

//second parameter is optional
export const shortenNumber = (num, noOfDecimalPlace) => {
  const si = {
    thousand: {
      num: "1E3",
      unit: "K",
    },
    million: {
      num: "1E6",
      unit: "M",
    },
    billion: {
      num: "1E9",
      unit: "B",
    },
  }

  const numStr = num.toString()
  if (numStr.length > 9) return convertToKM(num, si.billion, noOfDecimalPlace)
  else if (numStr.length > 6) return convertToKM(num, si.million, noOfDecimalPlace)
  else if (numStr.length > 3) return convertToKM(num, si.thousand, noOfDecimalPlace)
  return num.toString()
}

export const noOfdaysFromCurrentDate = (inputDateString) => {
  const inputDate = new Date(inputDateString)
  const currentDate = new Date()
  const diffTime = Math.abs(currentDate - inputDate)
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24))
}
